var module = angular.module('octopusApp.infrastructure');

module.directive("octoClippy", function () {
  return {
    restrict: 'E',
    templateUrl: 'infrastructure/directives/views/octo-clippy.html',
    replace: false,
    transclude: true
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/octo-clippy.js
// module id = 6658456014362672
// module chunks = 1